import { emailIsValidRe } from 'globals/utils';

interface Row {
  name: string;
  value: string;
}

const getFieldValue = (key: string, rows: Row[]) =>
  rows?.find(({ name }) => name === key)?.value;

export const getIsValid = (rows: Row[]): boolean => {
  const firstNameValue = getFieldValue('firstName', rows);
  const phoneNumberValue = getFieldValue('phoneNumber', rows);
  const emailValue = getFieldValue('email', rows);

  const isFirstNameValid = !!firstNameValue && firstNameValue.length >= 3;
  const isEmailValueValid = !!emailValue && !!emailValue.match(emailIsValidRe);
  const isPhoneNumberValid = !!phoneNumberValue && phoneNumberValue.length >= 5;

  return isFirstNameValid && isPhoneNumberValid && isEmailValueValid;
};
